import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00207 = new TileLayer({
  title: 'Máscara 20080904',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080904l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00207.setVisible(false);
  
const layer00206 = new TileLayer({
  title: 'Máscara 20080912',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080912l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00206.setVisible(false);
  
const layer00205 = new TileLayer({
  title: 'Máscara 20081006',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20081006l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00205.setVisible(false);
  
const layer00204 = new TileLayer({
  title: 'Máscara 20081115',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20081115l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00204.setVisible(false);
  
const layer00203 = new TileLayer({
  title: 'Máscara 20081123',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20081123l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00203.setVisible(false);
  
const layer00202 = new TileLayer({
  title: 'Máscara 20090211',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090211l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00202.setVisible(false);
  
const layer00201 = new TileLayer({
  title: 'Máscara 20090331',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090331l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00201.setVisible(false);
  
const layer00200 = new TileLayer({
  title: 'Máscara 20090408',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090408l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00200.setVisible(false);
  
const layer00199 = new TileLayer({
  title: 'Máscara 20090424',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090424l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00199.setVisible(false);

const layer00198 = new TileLayer({
  title: 'Máscara 20090502',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090502l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00198.setVisible(false);
 
const layer00197 = new TileLayer({
  title: 'Máscara 20090518',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090518l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00197.setVisible(false);
  
const layer00196 = new TileLayer({
  title: 'Máscara 20090526',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090526l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00196.setVisible(false);
  
const layer00195 = new TileLayer({
  title: 'Máscara 20090611',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090611l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00195.setVisible(false);
  
const layer00194 = new TileLayer({
  title: 'Máscara 20090627',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090627l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00194.setVisible(false);

const layer00193 = new TileLayer({
  title: 'Máscara 20090713',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090713l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00193.setVisible(false);
  
const layer00192 = new TileLayer({
  title: 'Máscara 20090729',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090729l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00192.setVisible(false);
  
const layer00191 = new TileLayer({
  title: 'Máscara 20090830',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20090830l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00191.setVisible(false);

export const grupoCapa01_13 = new LayerGroup({
  title: 'Ciclo Hidrológico 2008-2009',
  fold: 'close',
  layers: [layer00191, layer00192, layer00193, layer00194, layer00195, layer00196, layer00197, layer00198, layer00199, layer00200, layer00201, layer00202, layer00203, layer00204, layer00205, layer00206, layer00207]
});